import Vue from 'vue';
import VModal from 'vue-js-modal';
import AldNotification from 'plugins/Notification';
import AldSignalR from 'plugins/SignalR';
import VueCookieBot from '@ambitiondev/vue-cookiebot-plugin';
import VueSignaturePad from 'vue-signature-pad';

Vue.use(VModal);
Vue.use(AldNotification);
Vue.use(AldSignalR, { urlSignalr: process.env.API_HOST, skipNegotiation: true });
Vue.use(VueCookieBot, {
  cookieBotID: process.env.APP_COOKIEBOT_ID
});
Vue.use(VueSignaturePad);

// ---------------------------------------------------------------------------
// Register bootstrap-vue components, they start with 'b-', example: b-table
// ---------------------------------------------------------------------------
// See documentation: https://bootstrap-vue.js.org/docs/components/table
Vue.component('b-navbar', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/navbar/navbar" */ 'bootstrap-vue').then(
    ({ BNavbar }) => BNavbar
  )
);
Vue.component('b-navbar-nav', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/navbar/navbar-nav" */ 'bootstrap-vue').then(
    ({ BNavbarNav }) => BNavbarNav
  )
);
Vue.component('b-navbar-brand', () =>
  import(
    /* webpackChunkName: "components/bootstrap-vue/navbar/navbar-brand" */ 'bootstrap-vue'
  ).then(({ BNavbarBrand }) => BNavbarBrand)
);
Vue.component('b-navbar-toggle', () =>
  import(
    /* webpackChunkName: "components/bootstrap-vue/nav/b-navbar-toggle" */ 'bootstrap-vue'
  ).then(({ BNavbarToggle }) => BNavbarToggle)
);
Vue.component('b-nav-item-dropdown', () =>
  import(
    /* webpackChunkName: "components/bootstrap-vue/nav/nav-item-dropdown" */ 'bootstrap-vue'
  ).then(({ BNavItemDropdown }) => BNavItemDropdown)
);
Vue.component('b-collapse', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/nav/b-collapse" */ 'bootstrap-vue').then(
    ({ BCollapse }) => BCollapse
  )
);
Vue.component('b-dropdown-item', () =>
  import(
    /* webpackChunkName: "components/bootstrap-vue/dropdown/dropdown-item" */ 'bootstrap-vue'
  ).then(({ BDropdownItem }) => BDropdownItem)
);
Vue.component('b-row', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/layout/row" */ 'bootstrap-vue').then(
    ({ BRow }) => BRow
  )
);
Vue.component('b-col', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/layout/col" */ 'bootstrap-vue').then(
    ({ BCol }) => BCol
  )
);
Vue.component('b-card-group', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/card/card-group" */ 'bootstrap-vue').then(
    ({ BCardGroup }) => BCardGroup
  )
);
Vue.component('b-card', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/card/card" */ 'bootstrap-vue').then(
    ({ BCard }) => BCard
  )
);
Vue.component('b-card-body', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/card/card-body" */ 'bootstrap-vue').then(
    ({ BCardBody }) => BCardBody
  )
);
Vue.component('b-img-lazy', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/image/img-lazy" */ 'bootstrap-vue').then(
    ({ BImgLazy }) => BImgLazy
  )
);
Vue.component('b-alert', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/alert" */ 'bootstrap-vue').then(
    ({ BAlert }) => BAlert
  )
);
Vue.component('b-form', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/form/form" */ 'bootstrap-vue').then(
    ({ BForm }) => BForm
  )
);
Vue.component('b-input-group', () =>
  import(
    /* webpackChunkName: "components/bootstrap-vue/input-group/input-group" */ 'bootstrap-vue'
  ).then(({ BInputGroup }) => BInputGroup)
);
Vue.component('b-input-group-prepend', () =>
  import(
    /* webpackChunkName: "components/bootstrap-vue/input-group/input-group-prepend" */ 'bootstrap-vue'
  ).then(({ BInputGroupPrepend }) => BInputGroupPrepend)
);
Vue.component('b-input-group-text', () =>
  import(
    /* webpackChunkName: "components/bootstrap-vue/input-group/input-group-text" */ 'bootstrap-vue'
  ).then(({ BInputGroupText }) => BInputGroupText)
);
Vue.component('b-form-input', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/form-input" */ 'bootstrap-vue').then(
    ({ BFormInput }) => BFormInput
  )
);
Vue.component('b-form-checkbox', () =>
  import(
    /* webpackChunkName: "components/bootstrap-vue/form-checkbox/form-checkbox" */ 'bootstrap-vue'
  ).then(({ BFormCheckbox }) => BFormCheckbox)
);
Vue.component('b-button', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/button" */ 'bootstrap-vue').then(
    ({ BButton }) => BButton
  )
);
Vue.component('b-table', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/table" */ 'bootstrap-vue').then(
    ({ BTable }) => BTable
  )
);
Vue.component('b-link', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/link" */ 'bootstrap-vue').then(
    ({ BLink }) => BLink
  )
);

// ---------------------------------------------------------------------------
// Register Ald Automotive components, they start with 'ald-', example: ald-accordion
// ---------------------------------------------------------------------------
Vue.component('ald-accordion', () =>
  import(/* webpackChunkName: "components/ald-accordion" */ 'components/Accordion')
);
Vue.component('ald-alert', () =>
  import(/* webpackChunkName: "components/ald-alert" */ 'components/Alert')
);
Vue.component('ald-badge', () =>
  import(/* webpackChunkName: "components/ald-badge" */ 'components/Badge')
);
Vue.component('ald-button', () =>
  import(/* webpackChunkName: "components/ald-button" */ 'components/Button')
);
Vue.component('ald-button-group', () =>
  import(/* webpackChunkName: "components/ald-button-group" */ 'components/ButtonGroup')
);
Vue.component('ald-card', () =>
  import(/* webpackChunkName: "components/ald-card" */ 'components/Card')
);
Vue.component('ald-checkbox', () =>
  import(/* webpackChunkName: "components/ald-checkbox" */ 'components/Checkbox')
);
Vue.component('ald-check-list', () =>
  import(/* webpackChunkName: "components/ald-check-list" */ 'components/CheckList')
);
Vue.component('ald-collapse', () =>
  import(/* webpackChunkName: "components/ald-collapse" */ 'components/Collapse')
);
Vue.component('ald-icon', () =>
  import(/* webpackChunkName: "components/ald-icon" */ 'components/Icon')
);
Vue.component('ald-input', () =>
  import(/* webpackChunkName: "components/ald-input" */ 'components/Input')
);
Vue.component('ald-legal-conditions', () =>
  import(/* webpackChunkName: "components/ald-legal-conditions" */ 'components/LegalConditions')
);
Vue.component('ald-loader', () =>
  import(/* webpackChunkName: "components/ald-loader" */ 'components/Loader')
);
Vue.component('ald-markdown', () =>
  import(/* webpackChunkName: "components/ald-markdown" */ 'components/Markdown')
);
Vue.component('ald-modal', () =>
  import(/* webpackChunkName: "components/ald-modal" */ 'components/Modal')
);
Vue.component('ald-radio', () =>
  import(/* webpackChunkName: "components/ald-radio" */ 'components/Radios/Radio')
);
Vue.component('ald-radios', () =>
  import(/* webpackChunkName: "components/ald-radios" */ 'components/Radios')
);
Vue.component('ald-select', () =>
  import(/* webpackChunkName: "components/ald-select" */ 'components/Select')
);
Vue.component('ald-text', () =>
  import(/* webpackChunkName: "components/ald-text" */ 'components/Text')
);
Vue.component('ald-transition', () =>
  import(/* webpackChunkName: "components/ald-transition" */ 'components/Transition')
);

Vue.component('ald-fineviewer', () =>
  import(/* webpackChunkName: "components/ald-fineviewer" */ 'components/Fineviewer')
);
Vue.component('ald-damage-car', () =>
  import(/* webpackChunkName: "components/ald-damage-car" */ 'components/DamageCar')
);
Vue.component('ald-textarea', () =>
  import(/* webpackChunkName: "components/ald-textarea" */ 'components/Textarea')
);
Vue.component('ald-tab', () =>
  import(/* webpackChunkName: "components/ald-tab" */ 'components/Tabs/Tab')
);
Vue.component('ald-tabs', () =>
  import(/* webpackChunkName: "components/ald-tabs" */ 'components/Tabs')
);
Vue.component('ald-tabs-flow', () =>
  import(/* webpackChunkName: "components/ald-tabs-flow" */ 'components/TabsFlow')
);
Vue.component('ald-tool-tip', () =>
  import(/* webpackChunkName: "components/ald-tool-tip" */ 'components/ToolTip')
);
Vue.component('support-message-modal', () =>
  import(
    /* webpackChunkName: "components/support-message-modal" */ 'components/SupportMessageModal'
  )
);
Vue.component('ald-pagination', () =>
  import(/* webpackChunkName: "components/ald-pagination" */ 'components/Pagination')
);
Vue.component('ald-file-uploader', () =>
  import(/* webpackChunkName: "components/ald-file-uploader" */ 'components/FileUploader')
);
Vue.component('ald-signature', () =>
  import(/* webpackChunkName: "components/ald-signature" */ 'components/Signature')
);
